import { render } from "./technologyOfflineInfo.vue?vue&type=template&id=4fbffc4f&scoped=true"
import script from "./technologyOfflineInfo.vue?vue&type=script&lang=js"
export * from "./technologyOfflineInfo.vue?vue&type=script&lang=js"

import "./technologyOfflineInfo.vue?vue&type=style&index=0&id=4fbffc4f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbffc4f"]])

export default __exports__